<template>
<div class="site container hfeed inner-page">
  <HeadNav selectedLanguage="en" page="guides" />
  <div class="site-content page-primary">
    <article class="article-shell page-main-narrow">
      <Breadcrumbs :items="crumbs" />
      <h1>GB WhatsApp Tutorials &amp; How-To Use This App</h1>
      <p class="lede">
        Need help with GB WhatsApp? Find simple guides for installing, updating, backing up chats, using popular features, changing privacy settings, and fixing common problems.
      </p>
      <p>
        If you are looking for the APK itself, go to the
        <router-link to="/download/"><strong>GB WhatsApp Download</strong></router-link>
        page. For a quick overview of what the app offers, see the
        <router-link to="/features/"><strong>GB WhatsApp Features</strong></router-link>
        guide.
      </p>

      <h2 id="install-gb-whatsapp">How to Install GB WhatsApp</h2>
      <p>Before installing, back up any important chats and media from your current WhatsApp app.</p>
      <p>Download the APK, allow your browser or file manager to install apps from that source if Android asks, and open the file to start installation. Once installed, open GB WhatsApp, verify your phone number, and restore your chats if a compatible backup is available.</p>
      <p>Do not delete your previous WhatsApp data until you have checked that your important conversations and media are available.</p>
      <p>For the complete process, see our <a href="#install-gb-whatsapp"><strong>GB WhatsApp installation guide</strong></a>.</p>

      <h2>How to Update GB WhatsApp Without Losing Chats</h2>
      <p>Always back up your important chats before updating.</p>
      <p>If your current build supports normal updates, download the newer APK and install it over the existing version. <strong>Do not uninstall the old version first</strong>, as this can remove local app data.</p>
      <p>After the update, open several chats and check your photos and videos before deleting any previous backup.</p>

      <h2 id="backup-restore-whatsapp-chats">How to Backup &amp; Restore WhatsApp Chats</h2>
      <p>Create a backup before switching versions or changing WhatsApp clients.</p>
      <p>Open the backup settings in your current app and complete the available backup process. After installing GB WhatsApp, follow its restore options and give the app time to load your messages and media.</p>
      <p>Chat transfer between official WhatsApp and modified clients is not always guaranteed, so keep your original backup until you are sure everything has transferred correctly.</p>
      <p>Read our <a href="#backup-restore-whatsapp-chats"><strong>GB WhatsApp chat backup and restore guide</strong></a> for more detailed steps.</p>

      <h2>What to Do If GB WhatsApp Is Banned</h2>
      <p>If you receive a temporary restriction, avoid repeatedly trying to register or switching between different APKs.</p>
      <p>Check the message shown by WhatsApp and follow the available review instructions. If WhatsApp asks you to use the official app, switching back may be necessary.</p>
      <p>An <strong>Anti-Ban</strong> option cannot guarantee that an account will never be restricted. For a clearer explanation of the risks, see our <router-link to="/comparison/"><strong>GB WhatsApp vs Official WhatsApp comparison</strong></router-link>.</p>

      <h2>How to Enable Anti-Delete Messages</h2>
      <p>If your version supports Anti-Delete Messages, open the privacy settings and look for the message or chat privacy options.</p>
      <p>Enable the feature and test it with a conversation to make sure it works as expected. Menu names can differ between GB WhatsApp versions, so the option may be located in a slightly different place.</p>
      <p>Remember that this feature only affects what your app can display; it does not change what happens on the other person's device.</p>

      <h2>How to Customize GB WhatsApp Themes &amp; Fonts</h2>
      <p>Open the <strong>Themes</strong> or <strong>Customization</strong> section in GB WhatsApp to change the appearance of your chats and menus.</p>
      <p>Depending on your version, you may be able to change themes, fonts, colors, wallpapers, and other interface elements. If you install a custom theme, use a source you trust and avoid files that ask for unnecessary permissions.</p>
      <p>See the <router-link to="/features/"><strong>GB WhatsApp customization features</strong></router-link> page for an overview of the available options.</p>

      <h2>How to Use Two WhatsApp Accounts</h2>
      <p>If you want to use two accounts, your phone may support a built-in app-cloning or Dual Apps feature.</p>
      <p>Open your phone's app-cloning settings and check whether GB WhatsApp or your WhatsApp installation can be duplicated. Another option is to use separate supported app packages, depending on your device and the version you install.</p>
      <p>Make sure you know which phone number is connected to each account before completing verification.</p>

      <h2>How to Send Large Files on GB WhatsApp</h2>
      <p>GB WhatsApp may support larger file or media sizes than the standard WhatsApp app, depending on the version.</p>
      <p>Open the conversation, tap the attachment button, and select the file you want to send. For very large files, using the document option may help preserve the original file without normal media compression.</p>
      <p>If the upload fails, check your connection, available storage, and the file-size limit supported by your current version.</p>

      <h2>How to Enable DND Mode</h2>
      <p>Some GB WhatsApp builds include a DND option that can reduce WhatsApp activity or notifications without turning on Android's system-wide Do Not Disturb mode.</p>
      <p>Open the GB WhatsApp settings and look for <strong>DND</strong>, <strong>Do Not Disturb</strong>, or a similar option. Turn it on and test the result with another account to see exactly which notifications or activity indicators are affected.</p>
      <p>The location and behavior of this feature can vary between versions.</p>

      <h2>How to Set Up Auto Reply</h2>
      <p>If your GB WhatsApp build includes Auto Reply, open the feature from the messaging or additional settings section.</p>
      <p>Create a reply message, choose when it should trigger, and select the contacts or chats it applies to. Test the rule before relying on it for important conversations.</p>
      <p>Keep automated replies simple and avoid creating rules that could repeatedly respond to the same message.</p>

      <h2>How to Manage GB WhatsApp Privacy Settings</h2>
      <p>GB WhatsApp provides additional privacy controls in many builds.</p>
      <p>Open the privacy settings and review options for <strong>Last Seen, Online Status, Blue Ticks, Typing Status, Status Visibility</strong>, and other activity indicators.</p>
      <p>If you are looking for one specific privacy feature, our <router-link to="/features/"><strong>GB WhatsApp privacy features guide</strong></router-link> provides a quick overview before you change your settings.</p>

      <h2>How to Uninstall GB WhatsApp Safely</h2>
      <p>Before uninstalling GB WhatsApp, make sure you have backed up anything you want to keep.</p>
      <p>Check your chats, photos, videos, and documents first, then remove the app through your Android settings. If you plan to return to official WhatsApp, keep your backup until you have confirmed that the data you need is available there.</p>
      <p>You can also remove the old APK file from your Downloads folder after uninstalling.</p>

      <h2>GB WhatsApp Tips &amp; Tricks</h2>
      <p>Keep GB WhatsApp updated when you find a version that works well with your device, and back up important chats before making major changes.</p>
      <p>If a feature suddenly disappears after an update, check the version you are using before changing multiple settings. Some options can move or change between builds.</p>
      <p>For a broader look at what GB WhatsApp offers and how it differs from the standard app, visit the <router-link to="/"><strong>GB WhatsApp homepage</strong></router-link>.</p>
    </article>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/page-narrow-layout.scss';
import HeadNav from '@/components/HeadNav.vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';

export default {
  name: 'Guides',
  components: { HeadNav, Breadcrumbs },
  data() {
    return {
      crumbs: [
        { label: 'Home', to: '/' },
        { label: 'Guides', to: '' },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.inner-page .article-shell {
  width: 85%;
  margin: 0 auto;
  padding: 1rem 1.25rem 3.5rem;
  line-height: 1.7;
  font-size: 1.05rem;
  color: #222;
}
h1 {
  color: #128c7e;
  font-size: 2rem;
  line-height: 1.2;
}
h2 {
  color: #075e54;
  font-size: 1.35rem;
  margin-top: 2rem;
}
.lede {
  background: #f4fbf8;
  border-left: 4px solid #25d366;
  padding: 1rem 1.2rem;
  border-radius: 0 8px 8px 0;
}
a {
  color: #128c7e;
  font-weight: 600;
}
</style>
